// Authenticated
export const selectAuthAdminId = (state) => state.admin.authAdmin?._id;
export const selectAuthAdmin = (state) => state.admin.authAdmin;
